import React from 'react';
import styled from '@emotion/styled';
import {
  SegmentedViewLite,
  SegmentedViewControllerLite,
  SegmentedViewDataLite,
} from '../../../components/SegmentedView/SegmentedViewLite';
import PendingApps from './PendingApps/PendingApps';
import AllApps from './AllApps/AllApps';

export const jobSegmentedControllerConfig = [
  { title: 'All Applications' },
  { title: 'Pending Applications' },
];

const ApplicationSegment = () => {
  return (
    <Container>
      <SegmentedViewLite>
        <SegmentedViewControllerLite
          segmentedViewControllerTitle={jobSegmentedControllerConfig}
        />
        <SegmentedViewDataLite>
          <div>
            <AllApps />
          </div>
          <div>
            <PendingApps />
          </div>
        </SegmentedViewDataLite>
      </SegmentedViewLite>
    </Container>
  );
};

export default ApplicationSegment;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 1rem;
  width: 100%;
  border-radius: 10px;
  background: white;

  @media (max-width: 480px) {
    padding: 6px;
  }
`;
